/** Metadados de status da NF: rótulo e variante de cor do Badge. */
export const NF_STATUS = {
  rascunho:    { label: 'Rascunho',    variant: 'muted' },
  verificado:  { label: 'Verificado',  variant: 'default' },
  emitido:     { label: 'Emitido',     variant: 'success' },
  erro:        { label: 'Erro',        variant: 'destructive' },
  cancelado:   { label: 'Cancelado',   variant: 'destructive' },
  substituido: { label: 'Substituído', variant: 'warning' },
  correcao:    { label: 'Correção',    variant: 'warning' },
}

/** Ordem de exibição dos status nos filtros. */
export const NF_STATUS_ORDER = [
  'rascunho', 'verificado', 'emitido', 'erro', 'cancelado', 'substituido', 'correcao',
]

/** Status marcados por padrão no filtro da listagem. */
export const NF_STATUS_DEFAULT = ['rascunho', 'verificado']

export function statusMeta(status) {
  return NF_STATUS[status] || { label: status, variant: 'muted' }
}
